import React, { useState } from 'react';
import './style.css';
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter';
import { useUser } from '../../../Context/User';
const Index = ({ id, type, color, size }) => {
    return (
        <table className="product_description_table">
            <thead className="product_description_table_head">
                <tr className="product_description_table_head_row">
                    <td className="product_description_table_head_data">Colors:</td>
                    <td className="product_description_table_head_data">Size:</td>
                    {type !== 'view' && <td className="product_description_table_head_data">Size</td>}
                    {type !== 'view' && <td className="product_description_table_head_data">Position</td>}
                    {type !== 'view' && <td className="product_description_table_head_data">Alignment</td>}
                </tr>
            </thead>
            <tbody className="product_description_table_body">
                <Component
                    id={id}
                    type={type}
                    color={color}
                    size={size}
                    sizeDes={{ width: 15.7, height: 15.7 }}
                    pos={{ top: 15.7, left: 15.7 }}
                    align={[
                        <VerticalAlignCenterIcon className="algin_icon hori" />,
                        <VerticalAlignCenterIcon className="algin_icon vert" />,
                    ]}
                />
            </tbody>
        </table>
    );
};

const Component = ({ id, type, color, size, sizeDes, pos, align }) => {
    const { updateACartItem } = useUser();

    return (
        <tr className="product_description_table_body_row">
            <td className="product_description_table_body_data">
                <div className="product_description_table_body_data_colors">
                    <p style={{ backgroundColor: color }}>
                        <input
                            onChange={(e) => {
                                updateACartItem({ id: id, property: 'color', newValue: e.target.value });
                            }}
                            className="hiden-input"
                            type="color"
                        />
                    </p>
                </div>
            </td>
            <td className="product_description_table_body_data">
                <p className="product_description_table_body_data_size">
                    {size}
                    <select
                        onChange={(e) => {
                            updateACartItem({ id: id, property: 'size', newValue: e.target.value });
                        }}
                        className="hiden-input"
                    >
                        <option value="XS">XS</option>
                        <option value="S">S</option>
                        <option value="M">M</option>
                        <option value="L">L</option>
                        <option value="XL">XL</option>
                    </select>
                </p>
            </td>
            {type !== 'view' && (
                <td className="product_description_table_body_data">
                    <div className="product_description_table_body_data_sizes">
                        <p>W: {sizeDes.width}</p>
                        <p>H: {sizeDes.height}</p>
                    </div>
                </td>
            )}
            {type !== 'view' && (
                <td className="product_description_table_body_data">
                    <div className="product_description_table_body_data_position">
                        <p>T: {pos.top}</p>
                        <p>L: {pos.left}</p>
                    </div>
                </td>
            )}
            {type !== 'view' && (
                <td className="product_description_table_body_data">
                    <div className="product_description_table_body_data_alignment">{align.map((ele) => ele)}</div>
                </td>
            )}
        </tr>
    );
};

export default Index;
